import { useGetMsftCoSellEnumsQuery } from 'packages/tackle-api/src/co-sell-msft/picklistOptions';
import { z } from 'zod';

export const SelectOptionsSchema = z
  .array(
    z.object({
      display: z.string(),
      value: z.union([z.string(), z.number(), z.boolean()]),
    }),
  )
  .transform((options) =>
    options.map((option) => ({
      display: option.display,
      value: String(option.value),
    })),
  );

export default function useAssistanceRequestCodeOptions() {
  const enums = useGetMsftCoSellEnumsQuery({ enabled: true });
  const typeOfHelpEnums =
    enums?.data?.['inviteContexts.assistanceRequestCode'] ?? [];

  return SelectOptionsSchema.parse(typeOfHelpEnums);
}
